import Errors from './Errors'
import ErrorComponent from './ErrorComponent.vue'
import ErrorNoFormFieldComponent from "./ErrorNoFormFieldComponent";


class Validator{

    install(Vue){
        Vue.component('error', ErrorComponent);
        Vue.component('error-no-form-field', ErrorNoFormFieldComponent);

        Vue.mixin({

            beforeCreate(){
                //errors
                this.$options.$errors = {};
                Vue.util.defineReactive(this.$options, '$errors', Errors);
                if(!this.$options.computed){
                    this.$options.computed = {}
                }
                this.$options.computed["$errors"] = function() {
                    return this.$options.$errors;
                };
            },

        })

    }

}

export default new Validator()
